export const SET_LOADING = 'SET_LOADING'
export const SET_LOGINPOP = 'SET_LOGINPOP'
export const SET_USER = 'SET_USER'
export const SET_EID = 'SET_EID'
export const SET_PAGE = 'SET_PAGE'
export const SET_CLIENTTYPE = 'SET_CLIENTTYPE'
export const SET_ERRORMSG = 'SET_ERRORMSG'
export const SET_NODATATIP = 'SET_NODATATIP'
export const SET_REFRESH = 'SET_REFRESH'
export const SET_ISINIT = 'SET_ISINIT'
export const SET_INITAAENROLLMENT = 'SET_INITAAENROLLMENT'
export const SET_INITAAENROLLMENTLIST = 'SET_INITAAENROLLMENTLIST'
export const SET_NOWIDENTITY = 'SET_NOWIDENTITY'
export const SET_AAENROLLMENT = 'SET_AAENROLLMENT'
export const SET_CHANNELID = 'SET_CHANNELID'
export const SET_SHOWAPPTIPS = 'SET_SHOWAPPTIPS'
export const SET_SPECIALTOPICBUYDIALOGVISIBLE = 'SET_SPECIALTOPICBUYDIALOGVISIBLE'